<template>
  <div class="content">
    <div
      class="content-c"
      @scroll="handleScroll"
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
    >
      <div
        class="content-c--item"
        v-for="(item, index) in timeList"
        :key="index"
        @click="selectTab(index)"
      >
        <span :class="['tab-item', { active: index === selectIndex }]">
          {{ item }}
        </span>
      </div>
    </div>
    <p style="width: 100%; height: 1px; background: #55657e"></p>
    <div class="content-c--t">
      <div class="content-c--t2">
        <div
          class="content-c--i"
          v-for="(item, index) in cardList"
          :key="index"
        >
          <img :src="item.img" width="50" />
          <p
            class="font-color"
            v-html="item.title"
            style="font-size: 12px; line-height: 16px"
          ></p>
          <p :class="{ 'info-color': index === 5 }">
            <span class="wihte-color">
              {{ item.icon }}
              {{ $formatNumberWithCommas(item.value) }}</span
            >
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex m-t-15" style="margin-left: 2%">
      <img src="../../assets/img/home/mine-left.png" width="30" />
      <span class="m-l-5 f-t-15 f-w">{{ $lang.common_txt142 }}</span>
    </div>

    <div class="content-c--b">
      <div class="content-c--b2">
        <div class="content-c--b2t">
          <div class="content-c--b2c" style="padding: 0 10px">
            <div class="d-flex-c-s">
              <img src="../../assets/img/share/share_icon1.png" width="50" />
              <p class="font-color">
                {{ $lang.share_txt18 }} <br />{{ $lang.share_txt19 }}
              </p>
              <p class="wihte-color">
                {{ $formatNumberWithCommas(info.totalUserCount) }}
              </p>
            </div>
            <p class="c-line"></p>
            <div class="d-flex-c-s">
              <img src="../../assets/img/share/share_icon3.png" width="50" />
              <p class="font-color">
                {{ $lang.share_txt20 }} <br />{{ $lang.share_txt21 }}
              </p>
              <p class="wihte-color">
                {{ $formatNumberWithCommas(info.newRechargeCount) }}
              </p>
            </div>
            <p class="c-line"></p>
            <div class="d-flex-c-s">
              <img src="../../assets/img/share/share_icon1.png" width="50" />
              <p class="font-color">
                {{ $lang.share_txt22 }}<br />{{ $lang.share_txt23 }}
              </p>
              <p class="wihte-color">
                {{ getCurrency }}
                {{ $formatNumberWithCommas(info.newRechargeAmount) }}
              </p>
            </div>
          </div>
          <p class="w-line"></p>
          <div class="content-c--b3c">
            <div class="d-flex-c-s" style="padding-left: 2%">
              <img src="../../assets/img/share/share_icon1.png" width="50" />
              <p class="font-color">
                {{ $lang.share_txt24 }} <br />{{ $lang.share_txt25 }}
              </p>
              <p class="wihte-color">
                {{ getCurrency }}
                {{ $formatNumberWithCommas(info.totalRechargeAmount) }}
              </p>
            </div>
            <p class="c-line"></p>
            <div class="d-flex-c-s">
              <img src="../../assets/img/share/share_icon1.png" width="50" />
              <p class="font-color">
                {{ $lang.share_txt26 }} <br />{{ $lang.share_txt27 }}
              </p>
              <p class="wihte-color">
                <span>{{ getCurrency }}</span>
                {{ $formatNumberWithCommas(info.betEffc) }}
              </p>
            </div>
            <div style="width: 20%"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetTeamTotalReports, GetTeamReports } from '@/api/common'
export default {
  name: 'ShareTwo',
  components: {},
  props: {
    isSwipeable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectIndex: 0,
      cardList: [
        {
          title: this.$lang.share_txt28,
          value: 0,
          img: require('@/assets/img/share/share_icon1.png')
        },
        {
          title: this.$lang.share_txt29,
          value: 0,
          icon: this.getCurrency,
          img: require('@/assets/img/share/share_icon2.png')
        },
        {
          title: this.$lang.share_txt30,
          value: 0,
          img: require('@/assets/img/share/share_icon1.png')
        },
        {
          title: this.$lang.share_txt31,
          value: 0,
          icon: this.getCurrency,
          img: require('@/assets/img/share/share_icon2.png')
        },
        {
          title: this.$lang.share_txt32,
          value: 0,
          icon: this.getCurrency,
          img: require('@/assets/img/share/share_icon2.png')
        },
        {
          title: this.$lang.share_txt33,
          value: 0,
          icon: this.getCurrency,
          img: require('@/assets/img/share/share_icon2.png')
        }
      ],
      timeList: [
        this.$lang.billGame_txt4,
        this.$lang.billGame_txt5,
        this.$lang.billGame_txt6,
        this.$lang.billGame_txt7,
        this.$lang.billGame_txt8,
        this.$lang.billGame_txt9
      ],
      startDate: '',
      endDate: '',
      info: {
        totalUserCount: 0,
        newRechargeCount: 0,
        newRechargeAmount: 0,
        totalRechargeAmount: 0,
        betEffc: 0
      }
    }
  },
  methods: {
    handleScroll() {
      // 滚动时通知父组件暂停 swipeable
      this.$emit('pauseSwipe')
    },
    handleTouchStart() {
      // 触摸开始时通知父组件暂停 swipeable
      this.$emit('pauseSwipe')
    },
    handleTouchEnd() {
      // 触摸结束时通知父组件恢复 swipeable
      this.$emit('resumeSwipe')
    },
    selectTab(i) {
      this.selectIndex = i
      if (i === 0) {
        let startDate = this.$getTodayRange().slice(0, 19)
        let endDate = this.$getTodayRange().slice(20, 40)
        this.GetTeamReports(startDate, endDate)
        this.GetTeamTotalReports(startDate, endDate)
      } else if (i === 1) {
        let startDate = this.$getYesterdayRange().slice(0, 19)
        let endDate = this.$getYesterdayRange().slice(20, 40)
        this.GetTeamReports(startDate, endDate)
        this.GetTeamTotalReports(startDate, endDate)
      } else if (i === 2) {
        let startDate = this.$getThisWeekRange().slice(0, 19)
        let endDate = this.$getThisWeekRange().slice(20, 40)
        this.GetTeamReports(startDate, endDate)
        this.GetTeamTotalReports(startDate, endDate)
      } else if (i === 3) {
        let startDate = this.$getLastWeekRange().slice(0, 19)
        let endDate = this.$getLastWeekRange().slice(20, 40)
        this.GetTeamReports(startDate, endDate)
        this.GetTeamTotalReports(startDate, endDate)
      } else if (i === 4) {
        let startDate = this.$getThisMonthRange().slice(0, 19)
        let endDate = this.$getThisMonthRange().slice(20, 40)
        this.GetTeamReports(startDate, endDate)
        this.GetTeamTotalReports(startDate, endDate)
      } else if (i === 5) {
        let startDate = this.$getLastMonthRange().slice(0, 19)
        let endDate = this.$getLastMonthRange().slice(20, 40)
        this.GetTeamReports(startDate, endDate)
        this.GetTeamTotalReports(startDate, endDate)
      }
    },
    async GetTeamTotalReports(startDate, endDate) {
      const data = await GetTeamTotalReports({
        startDate: startDate,
        endDate: endDate
      })
      if (data.status === 'ok') {
        this.info = data.content
      } else {
        this.$toast({
          message: data.msg,
          icon: 'cross'
        })
      }
    },
    async GetTeamReports(startDate, endDate) {
      const data = await GetTeamReports({
        startDate: startDate,
        endDate: endDate
      })
      if (data.status === 'ok') {
        this.cardList[0].value = data.content.totalUserCount
        this.cardList[1].value = data.content.newRechargeAmount
        this.cardList[2].value = data.content.newRechargeCount
        this.cardList[3].value = data.content.totalRechargeAmount
        this.cardList[4].value = data.content.totalRechargeCount
        this.cardList[5].value = data.content.betEffcCount
      } else {
        this.$toast({
          message: data.msg,
          icon: 'cross'
        })
      }
    }
  },
  mounted() {
    let startDate = this.$getTodayRange().slice(0, 19)
    let endDate = this.$getTodayRange().slice(20, 40)
    this.GetTeamReports(startDate, endDate)
    this.GetTeamTotalReports(startDate, endDate)
  }
}
</script>
<style lang="less" scoped>
.content {
  padding-bottom: 20%;
}
.content-c {
  overflow-x: auto;
  display: flex;
  align-items: center;
  padding: 0 0 5px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

.content-c::-webkit-scrollbar {
  display: none;
}
.content-c--item {
  // color: @font-color;
  padding: 0px 6px;
  border-radius: 20px;
  white-space: nowrap;
}
.van-divider {
  margin: 10px 0;
  color: #676767;
}
.active {
  color: #ffffff;
  /* 添加渐变下边框 */
  // border-bottom: 2px solid;
  // border-image: linear-gradient(to right, #391624, #bc203e, #391624) 1;
  // padding-bottom: 3px !important;
}
.content-c--t {
  padding: 12px 10px;
  background: #ffffff;
  border-radius: 12px;
  margin: 10px auto;
  width: 96%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.content-c--t2 {
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 10px;
  display: flex;
  flex-flow: wrap row;
  justify-content: space-between;
  padding-bottom: 10px;
}
.content-c--i {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  border-radius: 15px;
  width: 33%; /* 或者指定具体的宽度 */
  // height: 87px;
  padding: 10px 0 0 20px;
  margin-bottom: 8px;
}
.content-c--b {
  padding: 0 2%;
}

.content-c--b2 {
  // height: 200px;
  width: 100%;
  border-radius: 12px;
  background: #ffffff;
  padding: 12px 10px;
  line-height: 18px;
  margin-top: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.content-c--b2t {
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 10px;
  padding: 10px 5px;
}
.content-c--b2c {
  display: flex;
  justify-content: space-between;
}
.c-line {
  width: 1.5px;
  height: 70px;
  background: linear-gradient(
    to bottom,
    rgba(97, 97, 97, 0.1),
    #ebd88d,
    rgba(97, 97, 97, 0.1)
  );
  margin-top: 20px;
}
.w-line {
  width: 70%;
  height: 1.5px;
  background: linear-gradient(
    to right,
    rgba(97, 97, 97, 0.1),
    #ebd88d,
    rgba(97, 97, 97, 0.1)
  );
  margin: 21px auto 15px;
}
.content-c--b3c {
  display: flex;
  justify-content: space-between;
}
.tab-item {
  display: inline-block;
  padding: 10px 12px;
  border-radius: 16px;
  // color: @font-color;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}

.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -5px;
  margin: 0 auto;
  width: 35px;
  height: 3px; /* 设置渐变阴影的高度 */
  background: linear-gradient(to right, #ffd117, #f7ba17, #ffd117);
}
.tab-item.active {
  color: #0077bb;
  position: relative;
  font-weight: bold;
}
.content-line {
  margin: 10px 0px;
  width: 100%;
  height: 1px;
  background: #55657e;
}
</style>
